import { render, staticRenderFns } from "./PenarikanDetail.vue?vue&type=template&id=48ccaae7&scoped=true&"
import script from "./PenarikanDetail.vue?vue&type=script&lang=js&"
export * from "./PenarikanDetail.vue?vue&type=script&lang=js&"
import style0 from "./PenarikanDetail.vue?vue&type=style&index=0&id=48ccaae7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ccaae7",
  null
  
)

export default component.exports